import React, { useState, useEffect } from "react";
import { DivTag } from "../../../Components/Tags/Tags";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { HeadTag, InputField } from "../../../Components/Tags/Tags";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import GaugeChart from "react-gauge-chart";
import {
  checkCrifCreditScore2,
  V2VerifyMobile,
} from "../../../Services/EquifaxCScore/highmark";
import CrifScoreReportModal from "./CrifScoreReport2";
import html2pdf from "html2pdf.js";
import { CrifCreditScoredata2, EV2MobileVerify } from "./data";
import Loader from "../../../Loader";
import { fetchProfile } from "../../../Services/profile/profileservice";
import { FaHandPointLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import { getServiceNameAndDetails } from "../../../Services";

const CrifCreditScore2 = () => {
   const endPoint = "/srv2/credit-report/crif";
      const [serviceName, setServiceName] = useState("");

  const [cusName, setCusName] = useState();
  const [mobile, setMobile] = useState("");
  const [panNo, setPanNo] = useState("");
  const [emailId, setEmailId] = useState("");
  const [dob, setDob] = useState("");
  const [aadhaar, setAadhaar] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  // const [creditScore, setCreditScore] = useState(CrifCreditScoredata2.data.credit_score);
  const [creditScore, setCreditScore] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [docType, setDocType] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [profileData, setProfileData] = useState([]);
  const [Equifaxv2Report, setEquifaxv2Report] = useState(null); // Put null i no
  const [Equifaxv2Error, setEquifaxv2Error] = useState(null); // Put Null if no
  const [submittedName, setSubmittedName] = useState("");
  const [submittedMobile, setSubmittedMobile] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isModalOpenMobile, setIsModalOpenMobile] = useState(false);
  const [mobileResponseData, setMobileResponseData] = useState(null);
  const [afterVerifyMobPan, setAfterVerifyMobPan] = useState("");
  const [afterVerifyMobAadhar, setAfterVerifyMobAadhaar] = useState("");
  const [afterMobName, setAfterMobName] = useState("");
  const [triggerVerifyContine, setTriggerVerifyContinue] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(
    sessionStorage.getItem("verifyClicked") === "true",
  );

  const maxScore = 900;

  const isValidDate = (dateString) => {
    if (!dateString) return false;

    // Check if the date is in YYYY-MM-DD format (HTML date input format)
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateRegex.test(dateString)) return false;

    // Parse the date and check if it's valid
    const date = new Date(dateString);
    const timestamp = date.getTime();

    // Check if the date is invalid
    if (typeof timestamp !== "number" || Number.isNaN(timestamp)) {
      return false;
    }

    // Check if the date is not in the future
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date > today) {
      return false;
    }

    // Check if the date is reasonable (not too old, e.g., before 1900)
    const minDate = new Date("1900-01-01");
    if (date < minDate) {
      return false;
    }

    // Check if the parsed date matches the input (prevents invalid dates like 2023-02-30)
    const [year, month, day] = dateString.split("-").map(Number);
    if (
      date.getFullYear() !== year ||
      date.getMonth() + 1 !== month ||
      date.getDate() !== day
    ) {
      return false;
    }

    return true;
  };

  const validateForm = () => {
    const newErrors = {};

    if (!firstName.trim()) {
      newErrors.firstName = "First Name is required.";
    }

    if (!lastName.trim()) {
      newErrors.lastName = "Last Name is required.";
    }

    if (mobile === "") {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number.";
    }

    if (dob === "") {
      newErrors.dob = "Date of Birth is required.";
    } else if (!isValidDate(dob)) {
      newErrors.dob = "Enter a valid date of birth.";
    }

    // if (panNo === "") {
    //     newErrors.panNo = 'PAN number is required.';
    // } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo.toUpperCase().trim())) {
    //     newErrors.panNo = 'Enter a valid PAN number (e.g., ABCDE1234F).';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlesubmit = async () => {
    try {
      // Validate the form first
      const isValid = validateForm();
      if (!isValid) {
        setEquifaxv2Report(null);
        setEquifaxv2Error(null);
        return;
      }
      setShowLoader(true);
      await GetCrifCreditScore2();

      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      showErrorToast("Validate the Required Field");
      setShowLoader(false);
    }
  };

  const handleDownloadPDF = () => {
    setIsDownloading(true);
    setTimeout(() => {
      const element = document.getElementById("CreditReport");

      if (element) {
        element.classList.remove("hidden");
        const clonedElement = element.cloneNode(true);
        clonedElement.style.maxHeight = "none";
        clonedElement.style.overflow = "visible";
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.appendChild(clonedElement);
        document.body.appendChild(tempDiv);
        html2pdf()
          .from(clonedElement)
          .set({
            margin: [0.2, 0.2, 0.2, 0.2],
            filename: "Crif Credit Report.pdf",
            image: { type: "jpeg", quality: 0.9 },
            html2canvas: { scale: 2, backgroundColor: "white" },
            jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
          })
          .save()
          .then(() => {
            document.body.removeChild(tempDiv);
            element.classList.add("hidden");
            setIsDownloading(false); //  Stop loading
          })
          .catch(() => {
            showErrorToast("Failed to generate PDF");
            element.classList.add("hidden");
            setIsDownloading(false); //  Stop loading
          });
      } else {
        showErrorToast("No data found to download");
      }
    }, 500);
  };

  async function GetCrifCreditScore2() {
    try {
      setShowLoader(true);
      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile: mobile,
        dob: dob,
        pan: panNo,
        email: emailId,
        aadhaar: aadhaar,
        first_name: firstName,
        last_name: lastName,
        toMail: true,
      };
      //  console.log("pay",payload);
      const response = await checkCrifCreditScore2(payload);
      //  console.log("res",response);
      const statusCode = response?.status?.code || response?.status;

      if (
        statusCode === 403 &&
        statusCode.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message === "Insufficient balance in wallet."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance.");
        return;
      }

      if (
        statusCode === 422 &&
        statusCode.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");
        return;
      }

      if (statusCode === 200) {
        //  Success
        setEquifaxv2Report(response?.data);
        setCreditScore(response.data?.credit_score);
        setSubmittedName(cusName);
        setCusName("");
        setLastName("");
        setFirstName("");
        setMobile("");
        setPanNo("");
        setEmailId("");
        setAadhaar("");
        setDob("");
        showSuccessToast(
          response?.credit_report_message?.message ||
            response?.message ||
            "Credit score fetched successfully.",
        );
      } else {
        //  All other errors
        setEquifaxv2Error(response?.error || response?.data || {}); // Now capturing error block
        setEquifaxv2Report(null);
        // setModalOpen(true);
        showErrorToast(
          response?.data?.message || // Fallback message in response.data
            response?.message || // Type 1 error (top-level message)
            response?.data?.error?.credit_report_message?.message || // Type 2 error
            response?.data?.error || // Direct string error like "Insufficient balance.
            "Something went wrong.", // Default fallback
        );
      }
    } catch (error) {
      console.error("Error in Crif Score:", error);
      setEquifaxv2Report(null);
      setEquifaxv2Error(error);
      showErrorToast("Something went wrong.");
    } finally {
      setShowLoader(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error("Error fetching profile data", error);
      }
    }
    fetchProfileData();
  }, []);

  const handleVerifyMobile = async () => {
    const newErrors = {};

    if (!firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!mobile.trim()) {
      newErrors.mobile = "Mobile is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setShowLoader(true);
      setIsVerifyDisabled(true);
      sessionStorage.setItem("verifyClicked", "true");

      const payload = {
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        mobile_number: mobile,
        first_name: firstName,
        last_name: lastName,
      };

      const response = await V2VerifyMobile(payload);

      if (
        response.status === 403 &&
        response.data.message === "Invalid or deactivated API key."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "Insufficient balance in wallet."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance in wallet.");
        return;
      }

      if (
        response.status === 422 &&
        response.data.message === "User not authorized to access this service."
      ) {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");

        return;
      }

      setMobileResponseData(response || response?.data || response?.data?.data);
      if (response?.data?.result !== null) {
        showSuccessToast(
          response?.status?.message ||
            response?.message ||
            "Consumer Details Fetched",
        );
      } else {
        showErrorToast(
          response?.status?.message || response?.message || "No Records Found",
        );
      }

      setShowLoader(false);
      setIsLoading(false);
      setIsModalOpenMobile(true);
      setIsVerifyDisabled(false);
    } catch (error) {
      console.error("Error verifying Consumer:", error);
      setIsVerifyDisabled(false);
      setShowLoader(false);
      setIsLoading(false);
    }
  };

  // Reset on page load
  useEffect(() => {
    sessionStorage.removeItem("verifyClicked");
  }, []);

  const VerifyContinue = () => {
    setTriggerVerifyContinue(true);
    setIsModalOpenMobile(false);
  };

  useEffect(() => {
    if (triggerVerifyContine) {
      // Priority: PAN first, then Aadhaar
      if (afterVerifyMobPan && !afterVerifyMobPan.startsWith("XXXX")) {
        setDocType("pan");
        setPanNo(afterVerifyMobPan);
      } else if (
        afterVerifyMobAadhar &&
        !afterVerifyMobAadhar.startsWith("XXXX")
      ) {
        setDocType("aadhaar");
        setPanNo(afterVerifyMobAadhar);
      }

      if (afterMobName) {
        const name = afterMobName || "";
        const nameParts = name.trim().split(" ");
        const firstNameFromName = nameParts[0] || "";
        const lastNameFromName =
          nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
        setFirstName(firstNameFromName);
        setLastName(lastNameFromName);
        //  setCusName(afterMobName);
      }

      // Reset trigger
      setTriggerVerifyContinue(false);
    }
  }, [
    triggerVerifyContine,
    afterVerifyMobPan,
    afterVerifyMobAadhar,
    afterMobName,
  ]);


    useEffect(() => {
    const getServiceName = async () => {
      try {
        const res = await getServiceNameAndDetails({
          end_point: endPoint,
        });

        if (res?.status?.code === 200) {
          setServiceName(res?.data?.service_name);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getServiceName();
  }, []);

  return (
    <>
      <Seo />
      {showLoader && <Loader />}

      <Header heading={serviceName} />
      <DivTag className="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-4 bg-white mt-2 shadow-md rounded-md">
        {/* Mobile */}

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            First Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="first_name"
            name="first_name"
            value={firstName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full required"
            placeholder="Enter First Name"
            onChange={(e) => {
              setFirstName(e.target.value);
              setErrors((prev) => ({ ...prev, firstName: "" }));
            }}
          />
          {errors.firstName && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.firstName}
            </p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            Last Name<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="text"
            id="last_name"
            name="last_name"
            value={lastName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border required border-blue-600 w-full"
            placeholder="Enter Last Name"
            onChange={(e) => {
              setLastName(e.target.value);
              setErrors((prev) => ({ ...prev, lastName: "" }));
            }}
          />
          {errors.lastName && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.lastName}
            </p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <div className="flex items-center justify-between mb-1">
            <HeadTag className="text-md font-serif">
              Mobile <strong className="text-red-700">*</strong>
            </HeadTag>

            {/* Small Button beside label */}
            <button
              type="button"
              onClick={() => setIsModalOpenMobile(true)}
              className="text-sm bg-green-600 text-white px-1 rounded hover:bg-green-700"
            >
              View
            </button>
          </div>

          {/* Input + Button */}
          <div className="flex">
            <InputField
              type="text"
              placeholder="Enter Mobile"
              className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
              name="mobile"
              id="mobile"
              onChange={(e) => setMobile(e.target.value)}
            />
            <button
              type="button"
              onClick={handleVerifyMobile}
              disabled={isVerifyDisabled}
              className={`bg-blue-600 text-white p-1 hover:bg-blue-700 ${isVerifyDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              Verify
            </button>
          </div>

          {errors.mobile && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.mobile}
            </p>
          )}

          {/* Modal */}
          {isModalOpenMobile && (
            <MobileDataModal
              setAfterMobName={setAfterMobName}
              mobileResponseData={mobileResponseData}
              setAfterVerifyMobPan={setAfterVerifyMobPan}
              setAfterVerifyMobAadhaar={setAfterVerifyMobAadhaar}
              VerifyContinue={VerifyContinue}
              onClose={() => setIsModalOpenMobile(false)}
            />
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            DOB<strong className="text-red-700">*</strong>
          </HeadTag>
          <input
            type="date"
            id="dob"
            name="dob"
            value={dob}
            max={new Date().toISOString().split("T")[0]}
            min="1900-01-01"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border required border-blue-600 w-full"
            onChange={(e) => {
              setDob(e.target.value);
              setErrors((prev) => ({ ...prev, dob: "" }));
            }}
          />
          {errors.dob && (
            <p className="text-red-600 text-sm font-mono mt-1">{errors.dob}</p>
          )}
        </DivTag>

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            Email
            <strong className="text-gray-500 text-xs font-thin">
              (optional)
            </strong>
          </HeadTag>
          <input
            type="text"
            id="emailId"
            name="emailId"
            value={emailId}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border required border-blue-600 w-full"
            onChange={(e) => {
              setDob(e.target.value);
              setErrors((prev) => ({ ...prev, emailId: "" }));
            }}
          />
          {errors.dob && (
            <p className="text-red-600 text-sm font-mono mt-1">{errors.dob}</p>
          )}
        </DivTag>

        {/* Pan No. */}
        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            Pan No.
            <strong className="text-gray-500 text-xs font-thin">
              (optional)
            </strong>
          </HeadTag>

          <InputField
            type="text"
            placeholder="Enter Pan"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
            name="panNo"
            id="panNo"
            value={panNo}
            onChange={(e) => setPanNo(e.target.value)}
          />
          {errors.panNo && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.panNo}
            </p>
          )}
        </DivTag>

        {/* Aadhaar . */}
        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif mb-1">
            Aadhaar
            <strong className="text-gray-500 text-xs font-thin">
              (optional)
            </strong>
          </HeadTag>

          <InputField
            type="text"
            placeholder="Enter Pan"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 w-full"
            name="aadhaar"
            id="aadhaar"
            value={aadhaar}
            onChange={(e) => setAadhaar(e.target.value)}
          />
          {errors.aadhaar && (
            <p className="text-red-600 text-sm font-mono mt-1">
              {errors.aadhaar}
            </p>
          )}
        </DivTag>
      </DivTag>
      <div className="flex justify-center">
        <button
          className={`rounded-md p-1 bg-blue-700 text-white mt-4 mb-1 h-8 px-3 ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
          onClick={handlesubmit}
          disabled={isLoading}
        >
          {isLoading ? "Submitting..." : "Get Credit Report"}
        </button>
      </div>

      <div className="w-full text-center">
        {errors.identification && (
          <p className="text-red-600 text-sm font-mono">
            {errors.identification}
          </p>
        )}
      </div>

      {Equifaxv2Report || Equifaxv2Error ? (
        <div class="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
          <span className="text-center font-bold md:text-xl">
            Hey{" "}
            {Equifaxv2Report?.first_name && Equifaxv2Report?.last_name
              ? `${Equifaxv2Report.first_name} ${Equifaxv2Report.last_name}`
              : Equifaxv2Error?.data?.first_name ||
                Equifaxv2Error?.error?.first_name ||
                "N/A"}
            !
          </span>

          <h2 class="text-xl md:text-xl font-semibold text-center">
            Your Credit Score
          </h2>

          <div class="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
            <div class="w-full md:w-[400px] relative md:mt-10">
              <span
                class="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70
    top-[60px] left-5 
    "
              >
                Poor
              </span>
              <span
                class="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26
    left-[69px] top-[-7px] 
    "
              >
                Average
              </span>
              <span
                class="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20
    left-[12rem] mt-[-9px] rotate-20
    "
              >
                Good
              </span>
              <span
                class="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70
    ml-[16rem] mt-[3.5rem]
    "
              >
                Excellent
              </span>

              <GaugeChart
                id="gauge-chart1"
                nrOfLevels={3}
                percent={creditScore / maxScore} // Normalized value for gauge
                needleColor={"#00008b"}
                textColor={"transparent"} // Hides the percentage text
                needleBaseColor={"red"}
                arcsLength={[0.3, 0.3, 0.3, 0.3]}
                colors={["#cc0000", "#e6e600", "#cc6600", "#009900"]}
              />
              <p
                class="text-black font-bold text-xl md:text-2xl absolute bottom-12  md:bottom-[5.5rem] 
                    left-1/2 transform -translate-x-1/2"
              >
                {creditScore}
              </p>
            </div>

            <div class="flex flex-col items-center md:items-start">
              <ul className="text-left text-sm md:text-base space-y-1 mt-4">
                <li>
                  <span className="font-bold">No of Accounts: </span>
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-NUMBER-OF-ACCOUNTS"]
                  }
                </li>
                <li>
                  <span className="font-bold">Active Accounts: </span>
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-ACTIVE-NUMBER-OF-ACCOUNTS"]
                  }
                </li>
                <li>
                  <span className="font-bold">Total Balance Amount: </span>
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-CURRENT-BALANCE"]
                  }
                </li>
                <li>
                  <span className="font-bold">Total Pass Due: </span>
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-OVERDUE-NUMBER-OF-ACCOUNTS"]
                  }
                </li>
                <li>
                  <span className="font-bold">Recent Account: </span>
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-SECURED-NUMBER-OF-ACCOUNTS"]
                  }
                </li>
                <li>
                  <span className="font-bold">Oldest Account: </span>
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-UNSECURED-NUMBER-OF-ACCOUNTS"]
                  }
                </li>
              </ul>

              <CrifScoreReportModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                Equifaxv2Report={Equifaxv2Report}
                Equifaxv2Error={Equifaxv2Error}
                submittedName={submittedName}
                submittedMobile={submittedMobile}
              />
              <div class="flex space-x-2 mt-4">
                <button
                  onClick={() => setModalOpen(true)}
                  class="bg-blue-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                >
                  View
                </button>
                <button
                  className="bg-red-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                  onClick={handleDownloadPDF}
                  disabled={isDownloading}
                >
                  {isDownloading ? "Downloading..." : "Download"}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="flex justify-center">
        <div class="flex flex-col items-center bg-gray-200 rounded-md shadow-lg shadow-blue-800 md:w-3/4 w-full p-1">
          <h1 class="font-bold text-2xl text-red-600 underline mb-2">
            Instructions
          </h1>
          <h2 class="text-xl font-bold text-center text-gray-800 mb-2 underline">
            How to get Best Financial Credit Report in Crif?
          </h2>

          <ul class="list-decimal list-inside text-left text-gray-700">
            <li className="">
              Enter the correct customer’s First name and Last Name.
            </li>
            <li>
              Enter the Mobile Number which is registered in credit bureau
              company.
            </li>
            <li>Enter the correct PAN Number.</li>
            <li>
              The Crif Credit Report only provide the details Report of that
              consumer which is available in the Crif Bureau.
            </li>
            <li>
              If you didn’t get the report means you should try with different
              details or in another bureau company.
            </li>
          </ul>
        </div>
      </div>

      <>
        <div
          id="CreditReport"
          className="hidden bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]"
        >
          <div className="a4-page">
            <div className="grid grid-cols-12 items-center gap-2 border-b pb-1 mt-1">
              {/* Logo - Start */}
              <div className="col-span-12 sm:col-span-3 flex justify-center sm:justify-start">
                <img
                  src="/assets/images/CrifScoreLogo.webp"
                  // src="https://imgs.search.brave.com/F-FGsx3dw-ufK7fWVZmHd93EObunBV0adl6hfaiK9Zs/rs:fit:0:180:1:0/g:ce/aHR0cHM6Ly9kMjh3/dThvNml0djg5dC5j/bG91ZGZyb250Lm5l/dC9pbWFnZXMvQ1JJ/RmhpZ2htYXJrcG5n/LTE1NzQ4NDY5NTk0/NjgucG5n"
                  className="w-12 sm:w-28 md:w-28"
                  alt="Company Logo"
                />
              </div>

              {/* Center Content */}
              <div className="col-span-12 sm:col-span-6 text-center">
                <h4 className="text-base sm:text-md md:text-md font-semibold">
                  Consumer Credit Report
                </h4>

                <p className="text-xs sm:text-xs mt-1">
                  <span className="font-semibold">For :</span>{" "}
                  <span className="font-bold">
                    {Equifaxv2Report?.credit_report?.[
                      "PERSONAL-INFO-VARIATION"
                    ]?.["NAME-VARIATIONS"]?.["VARIATION"]?.[2]?.["VALUE"] ||
                      (Equifaxv2Error?.data?.first_name &&
                      Equifaxv2Error?.data?.last_name
                        ? `${Equifaxv2Error?.data?.first_name} ${Equifaxv2Error?.data?.last_name}`
                        : Equifaxv2Error?.data?.first_name ||
                          Equifaxv2Error?.first_name ||
                          Equifaxv2Error?.error?.first_name ||
                          "N/A")}
                  </span>
                </p>
              </div>

              {/* End Section */}
              <div className="col-span-12  sm:col-span-3 text-center sm:text-right text-xs sm:text-[10px]">
                <p>
                  <span className="font-bold text-blue-600">CHM Ref:</span>{" "}
                  <span className="font-semibold">
                    {Equifaxv2Report?.credit_report?.["HEADER"]?.[
                      "REPORT-ID"
                    ] || "N/A"}
                  </span>
                </p>
                <p>
                  <span className="font-bold text-blue-600">
                    Date of Request:
                  </span>{" "}
                  <span className="font-semibold">
                    {Equifaxv2Report?.credit_report?.["HEADER"]?.[
                      "DATE-OF-REQUEST"
                    ] || "N/A"}
                  </span>
                </p>
                <p>
                  <span className="font-bold text-blue-600">
                    Date of Issue:
                  </span>{" "}
                  <span className="font-semibold">
                    {Equifaxv2Report?.credit_report?.["HEADER"]?.[
                      "DATE-OF-ISSUE"
                    ] || "N/A"}
                  </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center my-2">
              {Equifaxv2Error && (
                <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                  <p className="text-center text-red-600 font-bold">
                    Error:{" "}
                    <span className="font-normal">
                      {
                        // Case 1: credit_report_message.message_code
                        Equifaxv2Error?.error?.credit_report_message?.message
                          ?.replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          // Case 2: direct message
                          Equifaxv2Error?.message
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          Equifaxv2Report?.message
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          "Unknown Error"
                      }
                    </span>
                  </p>
                  <p className="text-center text-red-600 font-bold mt-1">
                    Code:{" "}
                    <span className="font-normal">
                      {
                        // Case 1: credit_report_message.message_code
                        Equifaxv2Error?.error?.credit_report_message?.message_code
                          ?.replace(/_/g, " ")
                          .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          // Case 2: direct message_code
                          Equifaxv2Error?.message_code
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          Equifaxv2Report?.message_code
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          "Unknown code"
                      }
                    </span>
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-center">
              <p className="font-bold text-black mb-2">Personal Details</p>
            </div>

            <div className="border border-blue-500 p-2 rounded-md">
              <div className="grid grid-cols-2 md:grid-cols-2  gap-1 text-xs">
                {/* Consumer Name */}
                <div>
                  <p>
                    <i className="font-semibold">Consumer Name : </i>
                    <span>
                      {Equifaxv2Report?.credit_report?.[
                        "PERSONAL-INFO-VARIATION"
                      ]?.["NAME-VARIATIONS"]?.["VARIATION"]?.[2]?.["VALUE"] ||
                        (Equifaxv2Error?.data?.first_name &&
                        Equifaxv2Error?.data?.last_name
                          ? `${Equifaxv2Error?.data?.first_name} ${Equifaxv2Error?.data?.last_name}`
                          : Equifaxv2Error?.data?.first_name ||
                            Equifaxv2Error?.first_name ||
                            Equifaxv2Error?.error?.first_name ||
                            "N/A")}
                    </span>
                  </p>
                </div>

                <div>
                  <p className="text-xs">
                    <i className="font-semibold">D.o.b</i>
                    <span>
                      {" "}
                      :{" "}
                      {Equifaxv2Report?.credit_report?.[
                        "PERSONAL-INFO-VARIATION"
                      ]?.["DATE-OF-BIRTH-VARIATIONS"]?.["VARIATION"]?.[0]?.[
                        "VALUE"
                      ] || "N/A"}
                    </span>
                  </p>
                </div>

                <div>
                  <p className="text-xs">
                    <i className="font-semibold">Age</i>
                    <span>
                      {" "}
                      :{" "}
                      {Equifaxv2Report?.credit_report?.[
                        "PERSONAL-INFO-VARIATION"
                      ]?.["DATE-OF-BIRTH-VARIATIONS"]?.["VARIATION"]?.[0]?.[
                        "VALUE"
                      ]
                        ? new Date().getFullYear() -
                          parseInt(
                            Equifaxv2Report?.credit_report[
                              "PERSONAL-INFO-VARIATION"
                            ]["DATE-OF-BIRTH-VARIATIONS"]["VARIATION"][0][
                              "VALUE"
                            ].split("-")[2],
                          )
                        : "N/A"}
                    </span>
                  </p>
                </div>

                <div>
                  <p className="text-xs">
                    <i className="font-semibold">Gender</i>
                    <span>
                      {" "}
                      :{" "}
                      {Equifaxv2Report?.CCRResponse?.CIRReportDataLst?.[0]
                        ?.CIRReportData?.IDAndContactInfo?.PersonalInfo
                        ?.Gender ||
                        Equifaxv2Error?.data?.gender ||
                        Equifaxv2Error?.gender ||
                        Equifaxv2Error?.error?.gender ||
                        "N/A"}
                    </span>
                  </p>
                </div>

                <div>
                  <p className="text-xs">
                    <i className="font-semibold">Mob</i>
                    <span>
                      {" "}
                      :{" "}
                      {Equifaxv2Report?.credit_report?.[
                        "PERSONAL-INFO-VARIATION"
                      ]?.["PHONE-NUMBER-VARIATIONS"]?.["VARIATION"]?.[0]?.[
                        "VALUE"
                      ] ||
                        Equifaxv2Error?.data?.mobile ||
                        Equifaxv2Error?.error?.mobile ||
                        "N/A"}
                    </span>
                  </p>
                </div>

                <div>
                  {/* PAN */}
                  <p className="text-xs">
                    <i className="font-semibold">PAN</i>:{" "}
                    {Equifaxv2Report?.credit_report?.[
                      "PERSONAL-INFO-VARIATION"
                    ]?.["PAN-VARIATIONS"]?.["VARIATION"]?.["VALUE"] ||
                      Equifaxv2Error?.data?.pan ||
                      "N/A"}
                  </p>

                  {/* UID (may be an array) */}
                  <p className="text-xs">
                    <i className="font-semibold">UID</i>:{" "}
                    {Array.isArray(
                      Equifaxv2Report?.credit_report?.[
                        "PERSONAL-INFO-VARIATION"
                      ]?.["UID-VARIATIONS"]?.["VARIATION"],
                    )
                      ? Equifaxv2Report?.credit_report?.[
                          "PERSONAL-INFO-VARIATION"
                        ]?.["UID-VARIATIONS"]?.["VARIATION"]
                          .map((item) => item?.["VALUE"])
                          .join(", ")
                      : Equifaxv2Report?.credit_report?.[
                          "PERSONAL-INFO-VARIATION"
                        ]?.["UID-VARIATIONS"]?.["VARIATION"]?.["VALUE"] ||
                        "N/A"}
                  </p>
                  <p className="text-xs">
                    <i className="font-semibold">Ration ID</i>:{" "}
                    {Array.isArray(
                      Equifaxv2Report?.credit_report?.[
                        "PERSONAL-INFO-VARIATION"
                      ]?.["RATION-CARD-VARIATIONS"]?.["VARIATION"],
                    )
                      ? Equifaxv2Report?.credit_report[
                          "PERSONAL-INFO-VARIATION"
                        ]?.["RATION-CARD-VARIATIONS"]?.["VARIATION"]
                          .map((item) => item?.["VALUE"])
                          .join(", ")
                      : Equifaxv2Report?.credit_report?.[
                          "PERSONAL-INFO-VARIATION"
                        ]?.["RATION-CARD-VARIATIONS"]?.["VARIATION"]?.[
                          "VALUE"
                        ] || "N/A"}
                  </p>

                  {/* Other ID */}
                  <p className="text-xs">
                    <i className="font-semibold">Other ID</i>:{" "}
                    {Equifaxv2Report?.credit_report?.[
                      "PERSONAL-INFO-VARIATION"
                    ]?.["OTHER-ID-VARIATIONS"]?.["VARIATION"]?.["VALUE"] ||
                      "N/A"}
                  </p>
                </div>
              </div>
            </div>

            <hr className="my-2" />

            <div className="  bg-blue-200 md:text-black text-black p-1 border rounded rounded-tl-xl rounded-tr-xl text-sm font-semibold">
              Address
            </div>
            <table className="min-w-full table-auto border border-black text-left text-sm">
              <thead className="bg-gray-200">
                <tr>
                  <th className="border border-black px-1 py-0.5">Sn</th>
                  <th className="border border-black px-0 py-0.5">Address</th>
                </tr>
              </thead>
              <tbody className="address-info text-xs">
                {Array.isArray(
                  Equifaxv2Report?.credit_report?.["PERSONAL-INFO-VARIATION"]?.[
                    "ADDRESS-VARIATIONS"
                  ]?.["VARIATION"],
                ) &&
                Equifaxv2Report?.credit_report["PERSONAL-INFO-VARIATION"]?.[
                  "ADDRESS-VARIATIONS"
                ]?.["VARIATION"].length > 0 ? (
                  Equifaxv2Report?.credit_report["PERSONAL-INFO-VARIATION"]?.[
                    "ADDRESS-VARIATIONS"
                  ]?.["VARIATION"]?.map((address, index) => (
                    <tr key={index}>
                      <td className="border border-black px-1 py-0.5 font-bold">
                        Address {index + 1}
                      </td>
                      <td className="border border-black px-0 py-1">
                        {address.VALUE}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="2"
                      className="border border-black px-2 py-1 text-center"
                    >
                      No address information available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Credit Score Section */}
            <div className=" bg-blue-300 md:text-black p-1 text-black mt-1 rounded-tl-md rounded-tr-md text-sm font-semibold">
              Crif Credit Score
            </div>
            <table className="min-w-full table-auto border border-black text-left text-sm">
              <thead className="bg-gray-200">
                <tr className="text-left text-xs">
                  <th className="border border-black px-1 py-1">Score Name</th>
                  <th className="border border-black px-1 py-1">
                    Scoring Elements
                  </th>
                  <th className="border border-black px-1 py-1">Score</th>
                </tr>
              </thead>
              <tbody className="scoreDetailsInfo text-xs">
                {(() => {
                  const scoresData =
                    Equifaxv2Report?.credit_report?.SCORES?.SCORE;

                  if (!scoresData) {
                    return (
                      <tr>
                        <td
                          colSpan="3"
                          className="border border-black px-1 py-0.5 text-center"
                        >
                          No score details available.
                        </td>
                      </tr>
                    );
                  }

                  // Ensure we always work with an array
                  const scoresArray = Array.isArray(scoresData)
                    ? scoresData
                    : [scoresData];

                  return scoresArray.map((score, idx) => (
                    <tr key={idx}>
                      <td className="border border-black px-1 py-0.5">
                        {score["SCORE-TYPE"] || "N/A"}
                      </td>

                      <td className="border border-black px-1 py-0.5">
                        <ul>
                          {score["SCORE-FACTORS"] ? (
                            score["SCORE-FACTORS"]
                              .split("|")
                              .filter(Boolean)
                              .map((factor, i) => <li key={i}>{factor}</li>)
                          ) : (
                            <li>No scoring elements available.</li>
                          )}
                        </ul>
                      </td>
                      <td className="border border-black px-1 py-1">
                        <div className="flex flex-col items-center justify-center bg-green-300 rounded-lg border-green-700 border p-1 w-16 h-14">
                          <span className="text-2xl font-bold text-blue-900">
                            {score["SCORE-VALUE"] || "N/A"}
                          </span>
                          <span className="text-xs font-semibold text-blue-900 mb-2">
                            Score
                          </span>
                        </div>
                      </td>
                    </tr>
                  ));
                })()}
              </tbody>
            </table>

            <div className="bg-blue-100 text-black p-2 mt-2 rounded-md text-sm font-semibold">
              Account Imformation:
            </div>

            {Array.isArray(
              Equifaxv2Report?.credit_report?.RESPONSES?.RESPONSE,
            ) && Equifaxv2Report.credit_report.RESPONSES.RESPONSE.length > 0 ? (
              Equifaxv2Report.credit_report.RESPONSES.RESPONSE.map(
                (item, index) => {
                  const account = item["LOAN-DETAILS"];

                  // Build yearly payment history
                  const buildPaymentHistory = (combinedHistory) => {
                    if (!combinedHistory) return { months: [], history: {} };

                    const months = [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                    ];
                    const yearsData = {};

                    const entries = combinedHistory.split("|").filter(Boolean);

                    entries.forEach((entry) => {
                      const [monthYear, status] = entry.split(",");
                      if (!monthYear || !status) return;

                      const [month, year] = monthYear.split(":");
                      const monthIndex = months.findIndex(
                        (m) => m.toLowerCase() === month.toLowerCase(),
                      );

                      if (monthIndex === -1 || !year) return;

                      if (!yearsData[year]) {
                        yearsData[year] = Array(12).fill("-");
                      }

                      yearsData[year][monthIndex] = status.trim();
                    });

                    return { months, history: yearsData };
                  };

                  const { months, history } = buildPaymentHistory(
                    account?.["COMBINED-PAYMENT-HISTORY"],
                  );

                  // Color coding function based on the image
                  const getStatusColor = (value) => {
                    if (value === "-") return "bg-white text-gray-400";
                    if (value.includes("XXX"))
                      return "bg-gray-200 text-gray-600";
                    if (value.includes("000") || value.includes("STD"))
                      return "bg-white text-gray-700";
                    return "bg-white text-gray-700";
                  };

                  return (
                    <div
                      key={index}
                      className="mb-2 border border-gray-300 rounded bg-white shadow-sm"
                    >
                      {/* Header Section - Blue Background */}
                      <div className="bg-blue-100 px-2 rounded-t grid grid-cols-5 md:grid-cols-5 gap-1 md:text-[10px] text-[9px]">
                        <div>
                          <span className="font-bold text-blue-600">
                            <span className="bg-black text-white px-1 py-1">
                              {" "}
                              {index + 1}
                            </span>{" "}
                            Account Type:
                          </span>
                          <div className="font-semibold text-red-600 py-0.5">
                            {account?.["ACCT-TYPE"] || "Gold Loan"}
                          </div>
                        </div>
                        <div>
                          <span className="font-bold text-blue-600">
                            Credit Grantor:
                          </span>
                          <div className="font-semibold text-red-600 py-0.5">
                            {account?.["CREDIT-GUARANTOR"] || "N/A"}
                          </div>
                        </div>
                        <div>
                          <span className="font-bold text-blue-600">
                            Account #:
                          </span>
                          <div className="font-semibold text-red-600 py-0.5">
                            {account?.["ACCT-NUMBER"] || "N/A"}
                          </div>
                        </div>
                        <div>
                          <span className="font-bold text-blue-600">
                            Lender Type:
                          </span>
                          <div className="font-semibold text-red-600 py-0.5">
                            {account?.["LENDER-TYPE"] || ""}
                          </div>
                        </div>
                        <div>
                          <span className="font-bold text-blue-600">
                            As on:
                          </span>
                          <div className="font-semibold text-red-600 py-0.5">
                            {account?.["DATE-REPORTED"] || "N/A"}
                          </div>
                        </div>
                      </div>

                      {/* Main Details Grid */}
                      <div className="grid grid-cols-3 md:grid-cols-3 gap-x-3 gap-y-0 p-2 md:text-[10px] text-[9px] bg-blue-100">
                        {/* Left Column */}
                        <div className="space-y-1">
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Ownership:
                            </span>{" "}
                            {account?.["OWNERSHIP-IND"] || "Individual"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Credit Limit:
                            </span>
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Cash Limit:
                            </span>
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Inst/Amt/Freq:
                            </span>
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Write off Date:
                            </span>
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Status:
                            </span>{" "}
                            {account?.["ACCOUNT-STATUS"] || "Closed"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Settlement Amt:
                            </span>
                            {account?.["SETTLEMENT-AMT"] || "0"}
                          </p>
                        </div>

                        {/* Middle Column */}
                        <div className="space-y-1">
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Disbursed Date:
                            </span>{" "}
                            {account?.["DISBURSED-DT"] || "N/A"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Last Payment Date:
                            </span>{" "}
                            {account?.["LAST-PAYMENT-DATE"] || "N/A"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Closed Date:
                            </span>{" "}
                            {account?.["CLOSED-DT"] || "N/A"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Tenure (months):
                            </span>{" "}
                            {account?.["REPAYMENT-TENURE"] || "N/A"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Account In Dispute:
                            </span>
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Income/Frq:
                            </span>
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Interest Rate:
                            </span>{" "}
                            {account?.["INTEREST-RATE"] || "N/A"}%
                          </p>
                        </div>

                        {/* Right Column */}
                        <div className="space-y-1">
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Disbd Amt/High Credit:
                            </span>{" "}
                            {account?.["DISBURSED-AMT"] || "0"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Current Balance:
                            </span>{" "}
                            {account?.["CURRENT-BAL"] || "0"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Last Paid Amt:
                            </span>{" "}
                            {account?.["ACTUAL-PAYMENT"] || "0"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Overdue Amt:
                            </span>{" "}
                            {account?.["OVERDUE-AMT"] || "0"}
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Principal Writeoff Amt:
                            </span>
                          </p>
                          <p className="font-semibold">
                            <span className="font-bold text-blue-800">
                              Total Writeoff Amt:
                            </span>{" "}
                            {account?.["WRITE-OFF-AMT"] || "0"}
                          </p>
                        </div>
                      </div>

                      {/* Payment History Table */}
                      <div className="">
                        <div className="text-black px-2 py-2 text-xs font-semibold">
                          Payment History/Asset Classification:
                        </div>

                        <div className="overflow-x-auto border border-gray-300">
                          <table className="w-full text-center text-xs border-collapse">
                            <thead>
                              <tr className="bg-gray-100">
                                <th className="border border-gray-300 p-1 font-semibold"></th>
                                {months.map((m, idx) => (
                                  <th
                                    key={idx}
                                    className="border border-gray-300 p-1 font-bold text-blue-700"
                                  >
                                    {m}
                                  </th>
                                ))}
                              </tr>
                            </thead>

                            <tbody>
                              {Object.keys(history).length > 0 ? (
                                Object.keys(history)
                                  .sort((a, b) => b - a)
                                  .map((year, yIdx) => (
                                    <tr key={yIdx} className="border-b">
                                      <td className="border border-gray-300 p-1 font-bold bg-gray-50">
                                        {year}
                                      </td>

                                      {history[year].map((value, mIdx) => (
                                        <td
                                          key={mIdx}
                                          className={`border border-gray-300 p-1 text-[9px] font-semibold ${getStatusColor(value)}`}
                                        >
                                          {value}
                                        </td>
                                      ))}
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={13}
                                    className="p-3 text-center text-gray-500"
                                  >
                                    No payment history available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  );
                },
              )
            ) : (
              <div className="border p-4 text-center text-xs bg-white">
                No account details available.
              </div>
            )}

            <div className="w-full overflow-x-auto">
              <table className="w-full border border-gray-300 text-[10px] font-semibold">
                <thead className="bg-blue-200">
                  <tr>
                    <th className="border px-1 py-0.5 text-left">Section</th>
                    <th className="border px-1 py-0.5 text-left">Code</th>
                    <th className="border px-1 py-0.5 text-left">
                      Description
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td className="border px-1 py-0.5">Account Summary</td>
                    <td className="border px-1 py-0.5">
                      Number of Delinquent Accounts
                    </td>
                    <td className="border px-1 py-0.5">
                      Number of accounts defaulted within last 6 months
                    </td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">
                      Account Information - Credit Grantor
                    </td>
                    <td className="border px-1 py-0.5">XXXX</td>
                    <td className="border px-1 py-0.5">
                      Credit grantor name undisclosed
                    </td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">
                      Account Information - Account #
                    </td>
                    <td className="border px-1 py-0.5">XXXX</td>
                    <td className="border px-1 py-0.5">
                      Account number undisclosed
                    </td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">
                      Payment History / Asset Classification
                    </td>
                    <td className="border px-1 py-0.5">XXX</td>
                    <td className="border px-1 py-0.5">
                      Data not reported by institution
                    </td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">
                      Payment History / Asset Classification
                    </td>
                    <td className="border px-1 py-0.5">STD</td>
                    <td className="border px-1 py-0.5">Standard Asset</td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">
                      Payment History / Asset Classification
                    </td>
                    <td className="border px-1 py-0.5">SUB</td>
                    <td className="border px-1 py-0.5">Sub-Standard Asset</td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">
                      Payment History / Asset Classification
                    </td>
                    <td className="border px-1 py-0.5">DBT</td>
                    <td className="border px-1 py-0.5">Doubtful Asset</td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">
                      Payment History / Asset Classification
                    </td>
                    <td className="border px-1 py-0.5">LOS</td>
                    <td className="border px-1 py-0.5">Loss Asset</td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">
                      Payment History / Asset Classification
                    </td>
                    <td className="border px-1 py-0.5">SMA</td>
                    <td className="border px-1 py-0.5">
                      Special Mention Account
                    </td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">CRIF Highmark Score</td>
                    <td className="border px-1 py-0.5">PERFORM - Consumer</td>
                    <td className="border px-1 py-0.5">
                      Score based on credit history & debt
                    </td>
                  </tr>

                  <tr>
                    <td className="border px-1 py-0.5">
                      Account Information - Account #
                    </td>
                    <td className="border px-1 py-0.5">CI-Ceased</td>
                    <td className="border px-1 py-0.5">
                      Institution ceased or membership terminated
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Recent Activity Section */}
            <div className="  bg-blue-300 md:text-black text-black p-1 rounded-tr-md rounded-tl-md text-sm font-semibold">
              Recent Activity (Last 90 Days)
            </div>
            <table className="min-w-full table-auto border border-black text-left text-xs">
              <thead className="bg-gray-200">
                <tr>
                  <th className="border border-black px-4 py-2">Member Name</th>
                  <th className="border border-black px-4 py-2">
                    Inquiry Date
                  </th>
                  <th className="border border-black px-4 py-2">Purpose</th>
                  <th className="border border-black px-4 py-2">
                    Ownership Type
                  </th>
                  <th className="border border-black px-4 py-2">Amount</th>
                  <th className="border border-black px-4 py-2">Remark</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(
                  Equifaxv2Report?.credit_report?.["INQUIRY-HISTORY"]?.HISTORY,
                ) ? (
                  Equifaxv2Report?.credit_report?.[
                    "INQUIRY-HISTORY"
                  ]?.HISTORY.map((history, idx) => (
                    <tr key={idx} className="border border-black">
                      <td className="border border-black px-4 py-2">
                        {history["MEMBER-NAME"]}
                      </td>
                      <td className="border border-black px-4 py-2">
                        {history["INQUIRY-DATE"]}
                      </td>
                      <td className="border border-black px-4 py-2">
                        {history["PURPOSE"]}
                      </td>
                      <td className="border border-black px-4 py-2">
                        {history["OWNERSHIP-TYPE"]}
                      </td>
                      <td className="border border-black px-4 py-2">
                        {history["AMOUNT"]}
                      </td>
                      <td className="border border-black px-4 py-2">
                        {history["REMARK"] || "N/A"}
                      </td>
                    </tr>
                  ))
                ) : Equifaxv2Report?.credit_report?.["INQUIRY-HISTORY"]
                    ?.HISTORY ? (
                  <tr className="border border-black">
                    <td className="border border-black px-4 py-2">
                      {
                        Equifaxv2Report?.credit_report?.["INQUIRY-HISTORY"]
                          ?.HISTORY["MEMBER-NAME"]
                      }
                    </td>
                    <td className="border border-black px-4 py-2">
                      {
                        Equifaxv2Report?.credit_report?.["INQUIRY-HISTORY"]
                          ?.HISTORY["INQUIRY-DATE"]
                      }
                    </td>
                    <td className="border border-black px-4 py-2">
                      {
                        Equifaxv2Report?.credit_report?.["INQUIRY-HISTORY"]
                          ?.HISTORY["PURPOSE"]
                      }
                    </td>
                    <td className="border border-black px-4 py-2">
                      {
                        Equifaxv2Report?.credit_report?.["INQUIRY-HISTORY"]
                          ?.HISTORY["OWNERSHIP-TYPE"]
                      }
                    </td>
                    <td className="border border-black px-4 py-2">
                      {
                        Equifaxv2Report?.credit_report["INQUIRY-HISTORY"]
                          .HISTORY["AMOUNT"]
                      }
                    </td>
                    <td className="border border-black px-4 py-2">
                      {Equifaxv2Report?.credit_report?.["INQUIRY-HISTORY"]
                        ?.HISTORY["REMARK"] || "N/A"}
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={6} className="border border-black text-center">
                      No inquiry history available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Summary Header */}
          <div className="bg-blue-300 text-black p-2 mt-1 text-sm font-semibold">
            Summary
          </div>

          {/* Table 1 – Accounts Overview */}
          <table className="min-w-full table-auto border border-gray-300 text-left text-xs mb-2">
            <thead className="bg-gray-200">
              <tr>
                <th className="border px-2 py-1">Number of Accounts</th>
                <th className="border px-2 py-1">Total Balance Amount</th>
                <th className="border px-2 py-1">
                  New Accounts (Last 6 Months)
                </th>
                <th className="border px-2 py-1">New Delinquent Accounts</th>
              </tr>
            </thead>
            <tbody className="bg-white hover:bg-gray-100">
              <tr>
                <td className="border px-2 py-1 text-blue-600 font-semibold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-NUMBER-OF-ACCOUNTS"]
                  }
                </td>
                <td className="border px-2 py-1 text-green-600 font-bold">
                  ₹
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-CURRENT-BALANCE"]
                  }
                </td>
                <td className="border px-2 py-1 text-yellow-600 font-semibold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "DERIVED-ATTRIBUTES"
                    ]?.["NEW-ACCOUNTS-IN-LAST-SIX-MONTHS"]
                  }
                </td>
                <td className="border px-2 py-1 text-red-600 font-semibold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "DERIVED-ATTRIBUTES"
                    ]?.["NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS"]
                  }
                </td>
              </tr>
            </tbody>
          </table>

          {/* Table 2 – Open & Overdue Accounts */}
          <table className="min-w-full table-auto border border-gray-300 text-left text-xs mb-2">
            <thead className="bg-gray-200">
              <tr>
                <th className="border px-2 py-1">Open Accounts</th>
                <th className="border px-2 py-1">Overdue Accounts</th>
                <th className="border px-2 py-1">
                  Length of Credit History (Years)
                </th>
                <th className="border px-2 py-1">
                  Length of Credit History (Months)
                </th>
                <th className="border px-2 py-1">Average Account Age</th>
              </tr>
            </thead>
            <tbody className="bg-white hover:bg-gray-100">
              <tr>
                <td className="border px-2 py-1 text-blue-600 font-semibold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-ACTIVE-NUMBER-OF-ACCOUNTS"]
                  }
                </td>
                <td className="border px-2 py-1 text-red-600 font-bold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-OVERDUE-NUMBER-OF-ACCOUNTS"]
                  }
                </td>
                <td className="border px-2 py-1 text-gray-700 font-semibold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "DERIVED-ATTRIBUTES"
                    ]?.["LENGTH-OF-CREDIT-HISTORY-YEAR"]
                  }
                </td>
                <td className="border px-2 py-1 text-gray-700 font-semibold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "DERIVED-ATTRIBUTES"
                    ]?.["LENGTH-OF-CREDIT-HISTORY-MONTH"]
                  }
                </td>
                <td className="border px-2 py-1 text-green-700 font-semibold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "DERIVED-ATTRIBUTES"
                    ]?.["AVERAGE-ACCOUNT-AGE-YEAR"]
                  }
                  y
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "DERIVED-ATTRIBUTES"
                    ]?.["AVERAGE-ACCOUNT-AGE-MONTH"]
                  }
                  m
                </td>
              </tr>
            </tbody>
          </table>

          {/* Table 3 – Credit & Sanction Summary */}
          <table className="min-w-full table-auto border border-gray-300 text-left text-xs mb-2">
            <thead className="bg-gray-200">
              <tr>
                <th className="border px-2 py-1">Secured Accounts</th>
                <th className="border px-2 py-1">Unsecured Accounts</th>
                <th className="border px-2 py-1">Sanctioned Amount</th>
                <th className="border px-2 py-1">Disbursed Amount</th>
              </tr>
            </thead>
            <tbody className="bg-white hover:bg-gray-100">
              <tr>
                <td className="border px-2 py-1 text-blue-600 font-semibold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-SECURED-NUMBER-OF-ACCOUNTS"]
                  }
                </td>
                <td className="border px-2 py-1 text-yellow-600 font-semibold">
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-UNSECURED-NUMBER-OF-ACCOUNTS"]
                  }
                </td>
                <td className="border px-2 py-1 text-green-600 font-bold">
                  ₹
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-SANCTIONED-AMOUNT"]
                  }
                </td>
                <td className="border px-2 py-1 text-purple-600 font-bold">
                  ₹
                  {
                    Equifaxv2Report?.credit_report?.["ACCOUNTS-SUMMARY"]?.[
                      "PRIMARY-ACCOUNTS-SUMMARY"
                    ]?.["PRIMARY-DISBURSED-AMOUNT"]
                  }
                </td>
              </tr>
            </tbody>
          </table>

          <div className="mt-1 mb-2">
            <h3 className="text-green-800 text-center font-bold">
              END of Report :{" "}
              {Equifaxv2Report?.credit_report?.["PERSONAL-INFO-VARIATION"]?.[
                "NAME-VARIATIONS"
              ]?.["VARIATION"]?.[2]?.["VALUE"] ||
                (Equifaxv2Error?.data?.first_name &&
                Equifaxv2Error?.data?.last_name
                  ? `${Equifaxv2Error?.data?.first_name} ${Equifaxv2Error?.data?.last_name}`
                  : Equifaxv2Error?.data?.first_name ||
                    Equifaxv2Error?.first_name ||
                    Equifaxv2Error?.error?.first_name ||
                    "N/A")}
            </h3>
          </div>
        </div>
      </>
    </>
  );
};

export default CrifCreditScore2;

const MobileDataModal = ({
  mobileResponseData,
  onClose,
  setAfterVerifyMobPan,
  setAfterVerifyMobAadhaar,
  setAfterMobName,
  VerifyContinue,
}) => {
  const rootData = mobileResponseData?.data || {};

  setAfterMobName(rootData?.name);
  setAfterVerifyMobPan(rootData?.pan);
  setAfterVerifyMobAadhaar(rootData?.aadhaar || "");

  const addresses = rootData?.address || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-3 rounded-lg shadow-2xl w-[90%] max-w-3xl max-h-[95vh] overflow-y-auto space-y-1">
        <div className="flex justify-between">
          <h2 className="text-2xl font-bold text-blue-700 border-b">
            Consumer Verification Details
          </h2>
          <button
            onClick={onClose}
            className="text-2xl text-red-600 hover:text-red-800"
          >
            ❌
          </button>
        </div>

        {rootData?.name && (
          <div className="w-full flex flex-col items-center mb-2">
            <h3 className="text-xl text-green-600 font-semibold text-center">
              Found In Experian
            </h3>
            <Link
              to="/ExperianScore2"
              className="flex items-center bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 gap-2 rounded transition duration-300 text-sm sm:text-base"
            >
              Result Found in Experian, Check Credit details in Experian for
              better result
              <FaHandPointLeft className="text-lg" />
            </Link>
          </div>
        )}

        {rootData?.idspay_message && (
          <div
            className={`flex justify-center border-2 p-3 rounded-lg ${
              rootData.idspay_message === "success"
                ? "bg-green-100 border-green-300"
                : "bg-red-100 border-red-300"
            }`}
          >
            <p
              className={`text-md font-serif ${
                rootData.idspay_message === "success"
                  ? "text-green-600"
                  : "text-red-500"
              }`}
            >
              {rootData.idspay_message}
            </p>
          </div>
        )}

        {/* Personal Info */}
        <div className="bg-blue-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-blue-600 mb-1">
            Personal Info
          </h3>
          <div className="grid grid-cols-2 gap-1 text-sm">
            <p>
              <strong>Full Name:</strong> {rootData?.name || "N/A"}
            </p>

            <p>
              <strong>DOB:</strong> {rootData?.dob || "N/A"}
            </p>
            <p>
              <strong>Gender:</strong> {rootData?.gender || "N/A"}
            </p>
            <p>
              <strong>PAN:</strong> {rootData?.pan || "N/A"}
            </p>
            <p>
              <strong>Email:</strong> {rootData?.email || "N/A"}
            </p>
          </div>
        </div>

        {/* Addresses */}
        <div className="bg-yellow-50 p-2 rounded-md shadow">
          <h3 className="text-lg font-semibold text-yellow-600 mb-2">
            Addresses
          </h3>
          {addresses.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-gray-300 rounded-md">
                <thead className="bg-yellow-100 text-gray-700">
                  <tr>
                    <th className="border px-2 py-1 text-left">Address #</th>
                    <th className="border px-2 py-1 text-left">Full Address</th>
                    <th className="border px-2 py-1 text-left">State</th>
                    <th className="border px-2 py-1 text-left">Postal Code</th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map((address, index) => (
                    <tr key={index} className="border-t">
                      <td className="border px-2 py-1">Address {index + 1}</td>
                      <td className="border px-2 py-1">
                        {[
                          address.first_line_of_address,
                          address.second_line_of_address,
                          address.third_line_of_address,
                        ]
                          .filter(Boolean)
                          .join(", ")}
                      </td>
                      <td className="border px-2 py-1">
                        {address.state || "N/A"}
                      </td>
                      <td className="border px-2 py-1">
                        {address.postal_code || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-sm">No address information available.</p>
          )}
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-center gap-3 mt-3">
          <button
            onClick={VerifyContinue}
            className="bg-green-500 text-white px-4 py-1 rounded-md hover:bg-green-600 transition"
          >
            Verify & Continue
          </button>
          <button
            onClick={onClose}
            className="bg-red-500 text-white px-4 py-1 rounded-md hover:bg-red-600 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
